import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import Badge from "@/components/ui/badge";
import IconContainer from "@/components/ui/icon-container";
import { User } from "@dreamhub/designsystem/icons";
import { TRANSLATION_PREFIX } from "@/components/global/Chat/components/meetingPrep/consts";
import MeetingPrepEmptyState from "@/components/global/Chat/components/meetingPrep/components/MeetingPrepEmptyState";
import { MeetingPrepKeyPerson } from "@/entities/meetingPrep/types";

const KeyPeopleTab: React.FC<{ keyPeople: MeetingPrepKeyPerson[] }> = ({
  keyPeople
}) => {
  const { t } = useTranslation();

  if (keyPeople.length === 0) {
    return <MeetingPrepEmptyState tab="keyPeople" />;
  }

  return (
    <div className="flex flex-col gap-4 py-4">
      {keyPeople.map((person, index) => (
        <div
          key={`${person.name}-${index}`}
          className="flex flex-col gap-1 px-4"
        >
          <div className="flex items-center gap-2 flex-wrap">
            <span className="flex items-center gap-2 min-w-0">
              <IconContainer size="sm" color="primary">
                <User />
              </IconContainer>
              <Text variant="body" className="break-words">
                {person.name}
              </Text>
            </span>
            {person.isMeetingParticipant && (
              <Badge
                text={t(`${TRANSLATION_PREFIX}.labels.willAttend`)}
                className="py-0.5 px-1.5 bg-white-4"
              />
            )}
          </div>
          <Text variant="bodyTertiary" className="break-words">
            {person.role}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default KeyPeopleTab;
